export const formatInrAmount = (value) => {
  if (value === null || value === undefined || value === "") return "-";

  const normalizedValue =
    typeof value === "number"
      ? value
      : Number(String(value).replace(/,/g, ""));

  if (Number.isNaN(normalizedValue)) {
    return String(value);
  }

  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(normalizedValue);
};
